










































































import { Component, Mixins } from 'vue-property-decorator'

import AppConfirmModal from '@/components/AppConfirmModal.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import { CURRENT_USER } from '@/gql/auth'
import { MY_USER } from '@/gql/user'
import { Common } from '@/mixins'

@Component({
  components: {
    AppConfirmModal,
    AppRouterLink,
    AppTitleBar
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    },
    myUser: {
      query: MY_USER,
      skip () { return !this.currentUser },
      variables () { return { username: this.currentUser.username } }
    }
  }
})
export default class extends Mixins(Common) {
  myUser = { alba: { pepperLevelInfo: { nextLevelMinFollowers: 0, currFollowers: 0, nextLevelMinOrderAmounts: 0, currOrderAmounts: 0, trialExpiredAt: 0 } } }
  isConfirmModalActive = false

  get levelInfo () {
    return this.myUser.alba.pepperLevelInfo
  }

  get currFollowersCap () {
    return Math.min(this.levelInfo.nextLevelMinFollowers, this.levelInfo.currFollowers)
  }

  get currOrderAmountsCap () {
    return Math.min(this.levelInfo.nextLevelMinOrderAmounts, this.levelInfo.currOrderAmounts)
  }

  get isUiPaybackEnabled () {
    return !!process.env.VUE_APP_UI_PAYBACK
  }

  onTextButtonClick () {
    window.open('https://www.notion.so/phlox/FAQ-4d1385e585894c9a89fa71d62cdb79d2', '_blank')
  }

  get expireString () {
    if (!this.levelInfo.trialExpiredAt) return ''

    const until = (this.levelInfo.trialExpiredAt - Date.now() / 1000) / (60 * 60 * 24)
    if (until <= 0) return ''
    if (until < 1) return '금일'
    return Math.floor(until) + '일 후'
  }
}
